import { render, staticRenderFns } from "./editMailingListModal.vue?vue&type=template&id=065613e0&"
import script from "./editMailingListModal.vue?vue&type=script&lang=js&"
export * from "./editMailingListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports